import { render, staticRenderFns } from "./CardsSetWidget.vue?vue&type=template&id=c0c4219a&"
import script from "./CardsSetWidget.vue?vue&type=script&lang=js&"
export * from "./CardsSetWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0c4219a')) {
      api.createRecord('c0c4219a', component.options)
    } else {
      api.reload('c0c4219a', component.options)
    }
    module.hot.accept("./CardsSetWidget.vue?vue&type=template&id=c0c4219a&", function () {
      api.rerender('c0c4219a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/CardsSetWidget.vue"
export default component.exports